module.exports = __webpack_public_path__ + "img/1F1F7-1F1F4.a0e3dace.svg";